import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import find from 'lodash/find'
import { Row, Col, Glyphicon } from 'react-bootstrap';
import Multiselect from 'react-widgets/lib/Multiselect';
import ModalLeaveWaitlist from './ModalLeaveWaitlist';
import MessageAddDropIsClosed from './MessageAddDropIsClosed';
import ModalAutoDrop from './ModalAutoDrop';
import StudentSteps from '../common/StudentSteps';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as coursesActions from '../../actions/coursesActionCreators';
import * as commonActions from '../../actions/commonActions';
import Spinner from 'react-spinkit';
import { LocationColumn } from './LocationRow';
import DiagnosticsModal from '../common/DiagnosticsModal'

class StudentManageWaitlistsPage extends React.Component {
  state = {
    run: {},
    student: {},
    pageLoaded: false,
    leaveModalOpenId: null,
    setAutoDropOpenId: null
  };

  async componentDidMount() {
    const { run, courses, studentActions, runActions, coursesActions, student, waitlist } = this.props;
    if (!run.id)
      await runActions.getRun().then(() => {
        studentActions.getAssignment();
      });
    if (!waitlist.isFetched && !waitlist.isOnFetch) {
      studentActions.getWaitlist();
    }

    if (courses.length == 0) await coursesActions.getAllCourses();
    if (!student.id) await studentActions.getStudent();
    this.setState({pageLoaded: true});
  }

  parseWaitlist = () =>
    this.props.waitlist.data.filter(wl => wl.status === 'pending' || wl.status === 'waitlist').map(item => {
      const course = this.props.courses.filter(course => course.id === item.course)[0] || {};
      return { ...item, course };
    });

  checkInvalidWaitlistItems = (waitlist) => waitlist.filter((listItem) => !listItem.implies_valid_schedule);

  handleRecheckValidity = (id) => () => {
    const { coursesActions, studentActions } = this.props;
    coursesActions.refreshValidity(id).then(() => {
      studentActions.getWaitlist();
    });
  }

  renderMultiselect = ({ input, meta: {touched, error}, ...rest }) => (
    <div>
      <Multiselect {...input}
        onBlur={input.onBlur}
        value={input.value || []}
        {...rest}
      />
      <div>
        {touched && (error && <span className="text-danger">{error}</span>)}
      </div>
    </div>
  )

  renderValidOrInvalidAlertBadges = (waitListValid) => (
    <div>
      { !waitListValid && (
        <div className="alert alert-danger mb-4" role="alert">
          <p>
            <strong>Please correct your flagged watitlist requests. </strong>
            An issue like a conflict, requirement, or credit limit may prevent you from being added to the class.
          </p>
        </div>
      )}
    </div>
  )

  renderWaitlist = () => {
    const waitlist = this.parseWaitlist();
    if (waitlist.length === 0) return <div>Empty waitlist</div>;

    const invalidWaitlistItems = this.checkInvalidWaitlistItems(waitlist);
    const waitListValid = invalidWaitlistItems.length === 0;
    const {
      leaveModalOpenId,
      setAutoDropOpenId
    } = this.state;
    const positionToLeave = waitlist.find(item => item.id === leaveModalOpenId);
    const positionToAutoDrop = waitlist.find(item => item.id === setAutoDropOpenId) || null;

    return (
      <div className="waitlistsContainer">
        {this.renderValidOrInvalidAlertBadges(waitListValid)}
        {waitlist.map(wl => {
          let positionOf = wl.waitlist_position ? `Waitlist position: ${wl.waitlist_position} of ${wl.course.waitlisted_students}` : 'Waitlist position: Pending'
          if (wl.waitlist_position >= 21) {
            positionOf = 'On the Waitlist'
          }
          const willAutoDrop = wl.conditional_drops
            .map(item => item.assignment)
            .map(item => find(this.props.assignments, {id: item}))
            .map(item => find(this.props.courses, {id: +item.course}).slug).join(', ')

          const courseLocations = commonActions.getCourseLocations(wl.course);

          const invalidItem = invalidWaitlistItems.find((i) => i.id === wl.id)
          return (
            <div className="waitlistsContainer_item" key={wl.id} style={{ position: 'relative'}}>
              <div>
                { invalidItem && (
                  <p className="small textColorRed">Flagged</p>
                )}
                { invalidItem && (
                  <button className="btn btn-danger" style={{ position: 'absolute', top: 15, right: 5 }} onClick={() => this.setState({ showDiagnosticsModal: wl.id})}>
                    Run Diagnostic
                  </button>
                  
                )}
                <p className="title textBold">
                  {wl.course.slug}: {wl.course.longname} ({wl.course.weight} {+wl.course.weight === 1 ? 'credit' : 'credits'}) -{' '}
                  <span className="instructor textNormal">{wl.course.instructor}</span>
                </p>
                <LocationColumn locations={courseLocations} />
                <p className="status">{positionOf}</p>
                { wl.conditional_drops.length ? (
                  <p className="processing textColorCyan textBold">
                    { willAutoDrop } will be automatically dropped if this waitlist request is accepted. <button type="button" className="button-flat button-add-autodrop" onClick={this.handleChangeAutoDropModalOpen.bind(null, wl.id)}>Change</button>
                  </p>
                ) : (
                  <p className="processing textColorCyan textBold">
                    <button type="button" className="button-flat button-add-autodrop" onClick={this.handleChangeAutoDropModalOpen.bind(null, wl.id)}>Add automatic drop</button>
                  </p>
                )}
                { invalidItem && <p className="small"><a onClick={this.handleRecheckValidity(wl.id)}>Re-check validity</a></p> }
              </div>
              <div>
                <Glyphicon className="color-gray hover-color-purple pointer" glyph="trash" onClick={this.handleLeavePosition.bind(this, wl.id)}/>
              </div>
            </div>
          )
        })}
        <ModalLeaveWaitlist
          position={positionToLeave}
          onClose={this.handleLeaveModalClose}
          />
        <ModalAutoDrop
          position={positionToAutoDrop}
          onClose={this.handleAutoDropModalClose}
          onSubmit={this.handleSubmitSetAutomaticDrop}
        />
        <DiagnosticsModal
          addId={this.state.showDiagnosticsModal}
          studentMode
          studentId={this.props.studentId}
          showModal={this.state.showDiagnosticsModal}
          onCancel={() => this.setState({ showDiagnosticsModal: false })}
        />
      </div>
    );
  };

  handleChangeAutoDropModalOpen = id => {
    this.setState({
      setAutoDropOpenId: id
    });
  };

  handleAutoDropModalClose = () => {
    this.setState({
      setAutoDropOpenId: null
    });
  };

  handleLeaveModalClose = () => {
    this.setState({
      leaveModalOpenId: null
    });
  };

  handleLeavePosition = leaveModalOpenId => {
    this.setState({
      leaveModalOpenId
    });
  };

  handleSubmitSetAutomaticDrop = selected => {
    const addId = this.state.setAutoDropOpenId;
    return this.props.coursesActions.addToAutoDrop({
      addId,
      ids: selected.map(item =>
        find(this.props.assignments, {course: item.id}).id
      )
    }).finally(() => {
      this.handleRecheckValidity(addId)();
      this.handleAutoDropModalClose();
    })
  }

  render() {
    const { waitlist, courses, run } = this.props;
    return (
      <div>
        <Row>
          <Col md={12}>
            {/* <div className="page-title">Waitlists</div> */}
            <StudentSteps active={1} isAssignmentCompleted={true} />
            {this.props.run.additional_manage_waitlist != null ? (
              <p className="mb-2 description-text" dangerouslySetInnerHTML={{__html: this.props.run.additional_manage_waitlist
                .replace('[[[primary_contact_email]]]',
                  `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)}}>
              </p>
            ) : (
                ''
              )}
            { run.assignment_complete && run.add_drop_open === false ? (
              <MessageAddDropIsClosed email={run.primary_contact} />
            ) : (
            <Row>
              <Col md={12}>
                <h2 className="page-subtitle">Waitlist Positions</h2>
                {run.assignment_complete ? (
                  waitlist.isFetched && courses.length > 0 ? (
                    this.renderWaitlist()
                  ) : (
                  <div className="spinner-box">
                    <Spinner spinnerName="three-bounce" className="mt-4" />
                  </div>
                  )
                ) : <h3>Add/drop period for this assignment period is not open at this time.</h3>}
              </Col>
            </Row>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    waitlist: state.waitlist,
    assignments: state.assignments,
    assignmentCourses: state.student.assignments
      ? commonActions.getCoursesObjsByIds(state.student.assignments.map(item => item.course), state.courses)
      : []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    coursesActions: bindActionCreators(coursesActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentManageWaitlistsPage);



// WEBPACK FOOTER //
// ./src/components/rank/StudentManageWaitlistsPage.js